import type { Location } from 'react-router-dom';

export function createLoginRedirectState(location: Location) {
  return { from: `${location.pathname}${location.search}${location.hash}` };
}

export function getLoginReturnPath(state: unknown) {
  if (!state || typeof state !== 'object' || !('from' in state) || typeof state.from !== 'string') {
    return '/';
  }

  return state.from.startsWith('/') && !state.from.startsWith('//') ? state.from : '/';
}
